// Typelizer digest 6f2dd5270c805e530eab3472b4dee873
//
// DO NOT MODIFY: This file was automatically generated by Typelizer.
import type { RouteDefinition, RouteOptions } from '../runtime'
import { buildUrl } from '../runtime'

export default {
  /** PATCH /c/:company_id/reminder_settings */
  update: (options?: RouteOptions): RouteDefinition<'patch'> => ({
    url: buildUrl('/c/:company_id/reminder_settings', {}, options),
    method: 'patch',
  }),
}
